import { toast } from 'react-toastify';

const DEFAULT_OPTIONS = {
  autoClose: 2000,
};

export const showToast = (
  message,
  type = 'info',
  body = '',
  options = {}
) => {
  const toastMap = {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warning: toast.warning,
  };

  const toastFn = toastMap[type] || toast;

  const content = (
    <div>
      <strong>{message}</strong>
      {body && <div style={{ fontSize: "14px", marginTop: "4px" }}>{body}</div>}
    </div>
  );

  toastFn(content, {
    ...DEFAULT_OPTIONS, 
    ...options,        
  });
};